import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      Oswaldo Díaz Díaz fue un gran conocedor e investigador de la Historia, pero antes que nada él se identificaba a sí
      mismo como educador, por lo que no se contentaba solo con leer mucho, sino que adoraba enseñar.
    </p>
    <p className="content justified">
      Quizá sea por eso que dedicó varios de sus escritos para niños a narrar episodios del descubrimiento de América,
      como “Los animales que ayudaron al almirante” (<i>Vida</i>, 1952), “El niño que miraba al mar” (
      <i>Cuentos tricolores</i>, 1967) o “Los papagayos de don Cristóforo” (<i>Cambam Bali</i>, 1942).
    </p>
    <p className="content justified">
      Como se ve a lo largo de su obra, Don Os elegía narrar las historias no desde las voces oficiales y victoriosas,
      sino desde las voces humildes y sencillas, como las de los niños.
    </p>
    <p className="content justified">
      Por esta razón, en “Los papagayos de don Cristóforo”, la voz cantante es la del travieso y pendenciero Diego
      Rojas, un chico de doce años que es enviado por su madre a hacer parte de la tripulación de don Cristóforo, a ver
      si deja de andar “perdiéndose, azotando calles sin otro oficio ni beneficio que malgastar el tiempo y hacer
      pilatunas”.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Díaz Díaz cuenta sobre la partida, habla de las historias de altamar y de cómo el hambre alborota a la tripulación
      y aclara: “Si este fuera un cuento para niños formales, diría ahora que el único que tuvo fe en Colón y que lo
      defendió de los marineros amotinados fue Diego, pero resulta que no hay tal. […] Diego tenía hambre como los
      demás, así que por su boca no hablaban buenos sentimientos sino el hambre que le retorcía las entrañas…”.
    </p>
    <p className="content justified">
      De este modo, no idealiza a su protagonista. Por el contrario, muestra su lado humano y le señala a los lectores
      que a veces uno se puede equivocar y hablar desde el hambre o la angustia, que no hay cosa tal como unos “niños
      formales”, sino simplemente niños con sentimientos, empatía, miedos; evidencia que a veces los niños pasan por esa
      “edad del crecimiento” que no solo da tanta hambre, también a veces inspira “malas ideas en la cabeza”.
    </p>
    <p className="content justified">
      “Los papagayos de don Cristóforo”, que tuvo una versión radioteatral para niños y muchachos dirigida por el
      profesor José Agustín Pulido Téllez probablemente durante los años 40, se centra en las aventuras de Diego a lo
      largo de su travesía de ida y vuelta a Guanahaní, el sitio donde desembarcaron.
    </p>
    <p className="content justified">
      Narra la manera en la que el chico se vincula con los niños indígenas, cómo consigue intercambiar con ellos un
      hermoso papagayo, y cuenta, además, que lo adopta, lo cuida y lo llama Timonel.
    </p>
    <p className="content justified">
      A su regreso a Europa, Timonel es el papagayo mejor cuidado y ha aprendido a decir varias frases en español. De
      esta manera, el pequeño Diego logra llamar la atención de don Cristóforo y de los reyes, haciéndose un lugar en la
      corte de la reina como paje oficial y cuidador del (ahora) ave real.
    </p>
    <p className="content justified">
      El cierre del cuento señala algo de la situación por la que pasaba Europa en el momento en el que este fue
      escrito. “Es posible que todavía ande Timonel gritando en algún lugar de Europa, pero, como las circunstancias
      están allí un tanto difíciles, tal vez tenga deseos de regresar a Guanahaní.”
    </p>
  </div>
);

export const sections = <div className="sectionsReview"></div>;
